import { mount } from 'svelte';
import AbonnementInfolettre from './abonnement-infolettre/AbonnementInfolettre.svelte';

mount(AbonnementInfolettre, {
  target: document.getElementById('abonnement-infolettre')!,
});
